<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('string.showLoan') }}
      </h3>
      <div class="box-tools">
        <asora-back-button />
      </div>
    </div>
    <div class="box-body">
      <template v-if="loan">
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('table.loanId') }}
          </div>
          <div class="col-md-9">
            {{ loan.search_loan_id || $t('string.na') }}
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('label.client') }}
          </div>
          <div class="col-md-9">
            {{ loan.borrow ? loan.borrow.name + ' ' + loan.borrow.last_name : $t('string.na') }}
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('label.clientId') }}
          </div>
          <div class="col-md-9">
            {{ loan.borrow ? loan.borrow.search_borrower_id : $t('string.na') }}
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('label.amount') }}
          </div>
          <div class="col-md-9">
            {{ loan.amount }} $
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('label.duration') }}
          </div>
          <div class="col-md-9">
            {{ loan.duration }} {{ loan.loan_type === 'Payday' ? $t('string.payday') : $t('string.personal') }}
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('label.purposeLoan') }}
          </div>
          <div class="col-md-9">
            {{ loan.purpose_loan ? loan.purpose_loan.name : $t('string.na') }}
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-md-3">
            {{ $t('label.status') }}
          </div>
          <div class="col-md-9">
            {{ loan.status }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            {{ $t('label.approvedAt') }}
          </div>
          <div class="col-md-9">
            {{ loan.approved_at }}
          </div>
        </div>
      </template>
      <template v-else>
        <p>{{ $t('string.noResult') }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import AsoraBackButton from '../../components/AsoraBackButton'

export default {
  name: 'Show',
  metaInfo () {
    return {
      title: this.$t('string.showLoanDetail'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { AsoraBackButton },
  data () {
    return {
      loan: {
        search_loan_id: null,
        borrow: {
          search_borrower_id: null
        },
        amount: null,
        duration: null,
        loan_type: null,
        purpose_loan: null,
        status: null,
        approved_at: null
      }
    }
  },
  methods: {
    getLoan () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/get-loan', {
        id: this.$route.params.loan_id
      }).then((res) => {
        if (res.data.data) {
          this.loan = res.data.data
        } else {
          this.loan = []
        }
      }).catch((error) => {
        this.onResponseError(error)
      })
    }
  },
  created () {
    this.getLoan()
  }
}
</script>

<style scoped>

</style>
